<div class="container" [ngClass]="{'invisible': isServer && homepageService._IS_IFRAME()}">
  <div class="not_found_section">
    <img src="assets/images/not_found.svg" alt="not_found" class="not_found_img mb-3"/>
    <h4 class="mb-4">The page you are looking for does not exist.</h4>
    <a href="https://minoan.com/" class="button_primary md">Go Home</a>
  </div>
</div>
